(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["homegym24-chatling"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.getElementById('hg24-chat-widget');
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const launcher = root.querySelector('#hg24-chat-launch');
    const status = root.querySelector('#hg24-chat-status');
    let loading = false;
    let loaded = false;
    let blocked = false;

    const syncVisibility = () => {
      const next = document.documentElement.matches('.m6pn-open, .m2a');
      launcher.hidden = next;
      if (loaded && next && !blocked && window.Chatling) {
        window.Chatling.minimize();
        window.Chatling.hideChatIcon();
      }
      blocked = next;
    };
    const showError = () => {
      loading = false;
      launcher.disabled = false;
      launcher.removeAttribute('aria-busy');
      status.hidden = false;
      status.textContent = status.dataset.error;
    };
    const openChat = () => {
      if (blocked || loading) return;
      if (loaded && window.Chatling) {
        window.Chatling.open();
        window.Chatling.hideChatIcon();
        return;
      }
      if (document.getElementById('chtl-script')) return;
      loading = true;
      launcher.disabled = true;
      launcher.setAttribute('aria-busy', 'true');
      status.hidden = false;
      status.textContent = status.dataset.loading;
      let watchedFrame = null;
      let readyTimer;
      const finishLoading = () => {
        if (!loading || !window.Chatling) return;
        clearTimeout(readyTimer);
        frameObserver.disconnect();
        loading = false;
        loaded = true;
        launcher.disabled = false;
        launcher.removeAttribute('aria-busy');
        status.hidden = true;
        syncVisibility();
        if (!blocked) window.Chatling.open();
        window.Chatling.hideChatIcon();
      };
      const watchForFrame = () => {
        const frame = document.getElementById('chtl-chat-iframe');
        if (!frame || watchedFrame === frame) return;
        watchedFrame = frame;
        frame.addEventListener('load', finishLoading, { once: true });
      };
      const frameObserver = new MutationObserver(watchForFrame);
      frameObserver.observe(document.body, { childList: true, subtree: true });
      const failLoading = () => {
        clearTimeout(readyTimer);
        frameObserver.disconnect();
        if (watchedFrame) watchedFrame.removeEventListener('load', finishLoading);
        if (window.Chatling) window.Chatling.destroy();
        const script = document.getElementById('chtl-script');
        if (script) script.remove();
        showError();
      };
      readyTimer = setTimeout(failLoading, 30000);
      root.querySelector('template').content.querySelectorAll('script').forEach((source) => {
        const script = document.createElement('script');
        Array.from(source.attributes).forEach((attribute) => script.setAttribute(attribute.name, attribute.value));
        script.textContent = source.textContent;
        if (script.src) {
          // Keep one consistent launcher; suppress the additional vendor launcher via its SDK setting.
          window.chtlConfig.chatIconVisible = false;
          script.addEventListener('load', watchForFrame, { once: true });
          script.addEventListener('error', failLoading, { once: true });
        }
        document.body.appendChild(script);
      });
    };
    launcher.addEventListener('click', openChat);
    new MutationObserver(syncVisibility).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    syncVisibility();
  })();
  } catch(e) { console.error(e); }
})();

})();
